import * as CookieConsent from "vanilla-cookieconsent";

export const CookieConsentModal = () => {
  // prevent double firing
  if (document.getElementById("cc-main")) return;
  // Enable dark mode
  document.body.classList.add("cc--darkmode");
  /**
   * 1. Setup the "Change Preferences" link listener
   */
  const cookieLink = document.querySelector(".js-change-cookies");
  if (cookieLink) {
    cookieLink.addEventListener("click", (e) => {
      e.preventDefault();
      CookieConsent.showPreferences();
    });
  }
  /**
   * 2. Analytics Init Helper
   */
  const initAnalytics = (cookie) => {
    if (cookie.categories.includes("analytics")) {
      console.log("Analytics enabled.");
      // Place your actual Google Analytics load script here
    } else {
      console.log("Analytics disabled.");
    }
  };
  /**
   * 3. Run CookieConsent
   */
  CookieConsent.run({
    // Forces modal to show if no choice has been made
    autoShow: true,
    // If you change your cookie policy later, increment this to force the modal back up
    revision: 5,
    guiOptions: {
      consentModal: {
        layout: "box",
        position: "bottom left",
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: "box",
        equalWeightButtons: true,
        flipButtons: false,
      },
    },
    categories: {
      necessary: {
        readOnly: true,
        enabled: true,
      },
      analytics: {
        enabled: false, // Default to OFF
        autoClear: {
          cookies: [
            {
              name: /^(_ga|_gid)/,
            },
          ],
        },
      },
      ads: {
        enabled: false,
      },
    },
    language: {
      default: "en",
      translations: {
        en: {
          consentModal: {
            title: "We value your privacy",
            description: "Our website uses essential cookies to ensure its proper operation and analytic tracking cookies to understand how you interact with it.",
            acceptAllBtn: "Accept all",
            acceptNecessaryBtn: "Reject all",
            showPreferencesBtn: "Manage preferences",
            footer: `<a href="/privacy-policy/">Privacy Policy</a><a href="/terms/">Terms and conditions</a>`,
          },
          preferencesModal: {
            title: "Cookie Preferences",
            acceptAllBtn: "Accept all",
            acceptNecessaryBtn: "Reject all",
            savePreferencesBtn: "Save preferences",
            closeIconLabel: "Close",
            sections: [
              {
                title: "Strictly necessary cookies",
                description: "These cookies are used for correct website operation and cannot be disabled.",
                linkedCategory: "necessary",
              },
              {
                title: "Performance and Analytics cookies",
                description: "These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site.",
                linkedCategory: "analytics",
                cookieTable: {
                  headers: {
                    name: "Cookie",
                    domain: "Domain",
                    desc: "Description",
                  },
                  body: [
                    {
                      name: "_ga",
                      domain: location.hostname,
                      desc: "Google Analytics ID",
                    },
                    {
                      name: "_gid",
                      domain: location.hostname,
                      desc: "Google Analytics Session ID",
                    },
                  ],
                },
              },
              {
                title: "Advertisement cookies",
                description: "Used to provide visitors with relevant ads and marketing campaigns.",
                linkedCategory: "ads",
              },
            ],
          },
        },
      },
    },
    onConsent: ({ cookie }) => {
      initAnalytics(cookie);
    },
    onChange: ({ cookie }) => {
      initAnalytics(cookie);
    },
  });
};
